import Response from '../base/Response';

export default class FailureResponse extends Response {

}
